import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UploadContext } from "@air/component-upload-dropzone";
import { Uploads } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { memo, useCallback, useContext } from "react";
import { ContentCollectionBackground } from "./ContentCollectionBackground";
import { ContentCollectionCompletedSidebar } from "./ContentCollectionCompletedSidebar";
export const ContentCollectionCompletedView = /*#__PURE__*/ memo(()=>{
    const { openUploader } = useContext(UploadContext);
    const _openUploader = useCallback(()=>{
        openUploader();
    }, [
        openUploader
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative z-0 flex size-full",
        children: [
            /*#__PURE__*/ _jsx(ContentCollectionBackground, {
                className: "absolute inset-x-0 top-20 -z-1 block w-[150%] -translate-x-1/4 md:hidden"
            }),
            /*#__PURE__*/ _jsx(ContentCollectionCompletedSidebar, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "relative z-0 hidden size-full flex-col items-center justify-center md:flex",
                children: [
                    /*#__PURE__*/ _jsx(ContentCollectionBackground, {
                        className: "absolute inset-0 -z-1 hidden size-full md:block"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "my-auto flex flex-col items-center gap-8 text-center",
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: "text-24 font-semibold text-grey-12",
                                children: "Your upload is complete!"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                appearance: "filled",
                                color: "blue",
                                onClick: _openUploader,
                                prefix: /*#__PURE__*/ _jsx(Uploads, {
                                    className: "size-4"
                                }),
                                size: "large",
                                children: "Upload more"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-12 font-medium text-grey-10",
                                children: "or drag and drop to upload"
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
ContentCollectionCompletedView.displayName = "ContentCollectionCompletedView";
